import { gql } from '@apollo/client'

const profileSwitchFragment = gql`
  fragment ProfileSwitchFragment on Profile {
    id
    pid
    fullname
    username
    cpf
    isCpfValid
    cpfName
    isB2BSelfService
    avatar: thumborAvatar {
      url: thumbUrl(size: "48x48")
    }
  }
`

export const TOPBAR_QUERY = gql`
  query TopbarRoot {
    root {
      viewer: me {
        ...ProfileSwitchFragment
        user {
          isAdmin
          email
          mainProfile {
            ...ProfileSwitchFragment
          }
          profiles {
            edges {
              node {
                ...ProfileSwitchFragment
              }
            }
          }
        }
        hasAccessToSomeBundle
        hasDoctrine
        hasPaidPlan
        hasJusIAFeatures
        isLawyer
        subscribeLink {
          label
          url
          isJusIA
        }
        boxProfileInfo {
          linkedAccount
        }
      }
    }
  }

  ${profileSwitchFragment}
`
